
import React from 'react';
import Layout from '@/components/layout/Layout';
import RequireAuth from '@/components/auth/RequireAuth';
import EscortDashboardLayout from '@/components/escort-dashboard/EscortDashboardLayout';
import EscortMessages from '@/components/escort-dashboard/messages/EscortMessages';

const EscortMessagesManager: React.FC = () => {
  return (
    <Layout>
      <RequireAuth requireRole="escort">
        <EscortDashboardLayout>
          <EscortMessages />
        </EscortDashboardLayout>
      </RequireAuth>
    </Layout>
  );
};

export default EscortMessagesManager;
